"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireWildcard(require("../buttons/Button"));

var _CancelTooltip = _interopRequireDefault(require("./../tooltips/CancelTooltip"));

var _ConfirmTooltip = _interopRequireDefault(require("../tooltips/ConfirmTooltip"));

var _EllipsisLoaderButton = _interopRequireDefault(require("./../general/EllipsisLoaderButton"));

var _Translator = _interopRequireDefault(require("../../util/i18n/Translator.js"));

var _underscore = _interopRequireDefault(require("underscore"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @callback ButtonBar~onCancel
*/

/**
* @callback ButtonBar~onDiscard
*/

/**
* @callback ButtonBar~onSave
*/

/**
* @class ButtonBar
* @desc Displays a set of button controls, most often "Save" and "Cancel", and sometimes "Discard"
*
* @param {ButtonBar.alignments} [alignment=left]
*     Which side of the bar the buttons go.
* @param {string} [className]
*     Class name(s) to add to the top-level container/div
* @param {string} [data-id=button-bar]
*     The data-id of the component
*
* @param {string} [cancelClassName]
*     Class name(s) to add to the "cancel" button
* @param {string} [cancelText]
*     Text to display on the "cancel" button. Note that the onCancel callback and cancelText props are required to
*     display the cancel button. If either is not provided, the button will not display.
* @param {Object} cancelTooltip
*     An object of the props required to generate a details tooltip that to confirm the closing of a modal.
* @param {string} cancelTooltip.confirmButtonText
*     Text to display for "save" button in the modal.
* @param {string} cancelTooltip.cancelButtontext
*     Text to display for "cancel" button in the modal.
* @param {node} cancelTooltip.label
*     Can pass anything such as numbers, string, DOM elements, arrays to the label.
* @param {node} cancelTooltip.messageText
*     Can pass anything such as numbers, string, DOM elements, arrays
*      to display the messages displayed in the modal.
* @param {function} cancelTooltip.onConfirm
*     Callback for when confirm button is clicked.
* @param {function} cancelTooltip.onCancel
*     Callback for when cancel button is clicked.
* @param {boolean} cancelTooltip.open
*     When true will open tooltip.
* @param {string} cancelTooltip.title
*     Text for the title of the modal.
*
* @param {string} [discardClassName]
*     Class name(s) to add to the "discard" button
* @param {string} discardText
*     Text to display on the "discard" button. Note that the onDiscard callback and discardText props are required to
*     display the discard button. If either is not provided, the button will not display.
* @param {boolean} [enableSavingAnimation=false]
*     Enables the ellipsis loading animation on the save button. This also disables the "discard" and "cancel" buttons.
* @param {array} [flags]
*     Set the flag for "use-portal" to render the confirmation tooltips with popper.js and react-portal
*
* @param {ButtonBar~onCancel} [onCancel]
*     Callback that will be triggered when the "cancel" button is clicked. Note that the onCancel callback and
*     cancelText props are required to display the cancel button. If either is not provided, the button will not
*     display.
* @param {ButtonBar~onDiscard} [onDiscard]
*     Callback that will be triggered when the "discard" button is clicked. Note that the onDiscard callback and
*     discardText props are required to display the discard button. If either is not provided, the button will not
*     display.
* @param {ButtonBar~onSave} onSave
*     Callback that will be triggered when the "save" button is clicked
* @param {ButtonBar~onSave} onSaveMouseDown
*     Callback that will be triggered when the "save" button gets a mousedown event.
*     Because mousedown fires blur events, it's sometimes possible for the save to get a mousedown event but never get the click.
*
* @param {string} [saveDisabledText]
*      Text for the help hint will be rendered when the same button has a the prop disabled set to true.
* @param {string} [saveClassName]
*     Class name(s) to add to the "save" button
* @param {string} saveText
*     Text to display on the "save" button
*
* @param {boolean} [saveDisabled=false]
*     Disabled the save button when true
* @param {Object} saveTooltip
*     An object of the props required to generate a details tooltip to confirm saving.
* @param {string} saveTooltip.confirmButtonText
*     Text to display for "save" button in the modal.
* @param {string} saveTooltip.cancelButtontext
*     Text to display for "cancel" button in the modal.
* @param {node} saveTooltip.label
*     Can pass anything such as numbers, string, DOM elements, arrays to the label.
* @param {node} saveTooltip.messageText
*     Can pass anything such as numbers, string, DOM elements, arrays
*     to display the messages displayed in the modal.
* @param {function} saveTooltip.onConfirm
*     Callback for when confirm button is clicked.
* @param {function} saveTooltip.onCancel
*     Callback for when cancel button is clicked.
* @param {boolean} saveTooltip.open
*     When true will open tooltip.
* @param {string} saveTooltip.title
*     Text for the title of the modal.
*
* @param {ButtonBar~onCancel} [onCancel]
*     Callback that will be triggered when the "cancel" button is clicked. Note that the onCancel callback and
*     cancelText props are required to display the cancel button. If either is not provided, the button will not
*     display.
* @param {ButtonBar~onDiscard} [onDiscard]
*     Callback that will be triggered when the "discard" button is clicked. Note that the onDiscard callback and
*     discardText props are required to display the discard button. If either is not provided, the button will not
*     display.
* @param {ButtonBar~onSave} onSave
*     Callback that will be triggered when the "save" button is clicked
* @param {ButtonBar~onSave} onSaveMouseDown
*     Callback that will be triggered when the "save" button gets a mousedown event.
*     Because mousedown fires blur events, it's sometimes possible for the save to get a mousedown event but never get the click.
* @param {boolean} [useButtonForCancel=false]
*     If you want to render the Cancel and Discard Changes links as buttons, set this to true.
* @param {boolean} [unfixed=false]
*     When set, the bar appears within the flow of the page content rather than fixed to the bottom of the window.
* @param {boolean} [visible=true]
*     Shows/hides the button bar. This is often set to true when a form data is "dirty"/has been edited
*
* @example
*     <ButtonBar
*         onCancel={this._handleCancel}
*         onDiscard={this._handleDiscard}
*         onSave={this._handleSave}
*         cancelText="Cancel"
*         discardText="Discard"
*         saveText="Save"
*         enableSavingAnimation={this.state.saving}
*         visible={this.state.showBar}>
*
*         <span style={{margin: "0 30px 0 0"}}>
*              Child content can added and will display to the left of the buttons by default.
*         </span>
*      </ButtonBar>
*
* @example button bar with tooltips
*     <ButtonBar
*        data-id="buttonbar"
*
*        cancelText="Cancel"
*        discardText="Discard"
*        saveText="Save"
*
*        onCancel={this._openCancelTooltip}
*        onDiscard={this._handleDiscard}
*        onSave={this._openSaveTooltip}
*
*        enableSavingAnimation={this.state.saving}
*        visible={this.state.showBar}
*        saveDisabled={this.state.saveDisabled}
*        unfixed={this.state.unfixed}
*
*        cancelTooltip={{
*            title: "Cancel Confirmation",
*            open: this.state.showCancelTooltip,
*            onConfirm: this._handleCancel,
*            onCancel: this._closeCancelTooltip,
*            messageText: "Are you sure you want to cancel these changes?",
*            confirmButtonText: "Yes",
*            cancelButtonText: "No"
*        }}
*
*        saveTooltip={{
*            title: "Save Confirmation",
*            open: this.state.showSaveTooltip,
*            onConfirm: this._handleSave,
*            onCancel: this._closeSaveTooltip,
*            messageText: "Are you sure you want to save these changes?",
*            confirmButtonText: "Yes",
*            cancelButtonText: "No"
*        }}>
*
*        <span style={{ margin: "0 30px 0 0" }}>
*            Child content can added and will display to the left of the buttons by default.
*        </span>
*    </ButtonBar>
* @example example with helphint on disabled button
*     <ButtonBar
*         onCancel={this._handleCancel}
*         onDiscard={this._handleDiscard}
*         onSave={this._handleSave}
*         cancelText="Cancel"
*         discardText="Discard"
*         saveText="Save"
*         enableSavingAnimation={this.state.saving}
*         visible={this.state.showBar}
*         saveDisabled={this.state.saveDisabled}
*         savedDisabledText="this is disabled">
*
*         <span style={{margin: "0 30px 0 0"}}>
*              Child content can added and will display to the left of the buttons by default.
*         </span>
*      </ButtonBar>
*
*/

/**
 * @enum {string}
 * @alias ButtonBar.alignments
 */
var alignments = {
  /** left */
  LEFT: "left",
  RIGHT: "right"
};

var ButtonBar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ButtonBar, _React$Component);

  var _super = _createSuper(ButtonBar);

  function ButtonBar() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleSave", function (e) {
      if (!_this.props.enableSavingAnimation) {
        _this.props.onSave(e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getCancelButtonMarkup", function () {
      var cancelClassName = (0, _classnames.default)(_this.props.cancelClassName, {
        "cancel": _this.props.useButtonForCancel && !_this.props.cancelClassName,
        disabled: _this.props.enableSavingAnimation,
        "button-bar__cancel-link": !_this.props.useButtonForCancel
      });
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": _this.props["data-id"] + "-cancel",
        className: cancelClassName,
        onClick: _this.props.onCancel,
        disabled: _this.props.enableSavingAnimation,
        type: _this.props.useButtonForCancel ? _Button.buttonTypes.CANCEL : _Button.buttonTypes.LINK
      }, _this.props.cancelText || _Translator.default.translate("cancel"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getSaveButtonMarkup", function () {
      return /*#__PURE__*/_react.default.createElement(_EllipsisLoaderButton.default, {
        "data-id": _this.props["data-id"] + "-save",
        className: (0, _classnames.default)(_this.props.saveClassName || "primary", "button-bar__save", {
          disabled: _this.props.saveDisabled
        }),
        disabled: _this.props.saveDisabled,
        disabledText: _this.props.saveDisabledText,
        loading: _this.props.enableSavingAnimation,
        onClick: _this._handleSave,
        onMouseDown: _this.props.onSaveMouseDown,
        text: _this.props.saveText || _Translator.default.translate("save"),
        noSpacing: _this.props.alignment === "right"
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderCancelButton", function () {
      return _this.props.cancelTooltip ? /*#__PURE__*/_react.default.createElement(_CancelTooltip.default, (0, _extends2.default)({
        "data-id": _this.props["data-id"],
        label: _this._getCancelButtonMarkup(),
        placement: "top left"
      }, _this.props.cancelTooltip)) : _this._getCancelButtonMarkup();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderSaveButton", function () {
      var _ref = _this.props.saveTooltip || {},
          cancelButtonText = _ref.cancelButtonText,
          confirmButtonText = _ref.confirmButtonText,
          messageText = _ref.messageText,
          props = (0, _objectWithoutProperties2.default)(_ref, ["cancelButtonText", "confirmButtonText", "messageText"]);

      return _this.props.saveTooltip ? /*#__PURE__*/_react.default.createElement(_ConfirmTooltip.default, (0, _extends2.default)({
        buttonLabel: confirmButtonText,
        cancelText: cancelButtonText,
        "data-id": _this.props["data-id"] + "-save-tooltip",
        label: _this._getSaveButtonMarkup(),
        onConfirm: _this._handleSave,
        placement: "top left",
        showClose: false
      }, props), messageText) : _this._getSaveButtonMarkup();
    });
    return _this;
  }

  (0, _createClass2.default)(ButtonBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignment = _this$props.alignment,
          children = _this$props.children;

      var discardText = this.props.discardText || _Translator.default.translate("discard"),
          containerClassName = {
        "page-controls-primary": true,
        hidden: !this.props.visible,
        "button-bar--left-align": this.props.alignment === "left"
      },
          discardClassName = (0, _classnames.default)(this.props.discardClassName, {
        "cancel": this.props.useButtonForCancel && !this.props.discardClassName,
        disabled: this.props.enableSavingAnimation,
        "button-bar__cancel-link": !this.props.useButtonForCancel
      }),
          unfixedClassName = {
        "page-controls-primary--unfixed": this.props.unfixed
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: (0, _classnames.default)(this.props.className, containerClassName, unfixedClassName)
      }, alignment === "right" && children, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-bar__buttons"
      }, this._renderSaveButton(), this.props.cancelText && this.props.onCancel && this._renderCancelButton(), this.props.discardText && this.props.onDiscard && /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": this.props["data-id"] + "-discard",
        className: discardClassName,
        onClick: this.props.onDiscard,
        disabled: this.props.enableSavingAnimation,
        type: this.props.useButtonForCancel ? _Button.buttonTypes.CANCEL : _Button.buttonTypes.LINK
      }, discardText)), alignment === "left" && children);
    }
  }]);
  return ButtonBar;
}(_react.default.Component);

(0, _defineProperty2.default)(ButtonBar, "propTypes", {
  alignment: _propTypes.default.oneOf((0, _values.default)(alignments)),
  cancelClassName: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  cancelTooltip: _propTypes.default.shape({
    confirmButtonText: _propTypes.default.string,
    cancelButtonText: _propTypes.default.string,
    label: _propTypes.default.node,
    messageText: _propTypes.default.node,
    onConfirm: _propTypes.default.func,
    onCancel: _propTypes.default.func,
    open: _propTypes.default.bool,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  discardClassName: _propTypes.default.string,
  discardText: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  saveDisabledText: _propTypes.default.string,
  onCancel: _propTypes.default.func,
  onDiscard: _propTypes.default.func,
  onSave: _propTypes.default.func,
  onSaveMouseDown: _propTypes.default.func,
  saveClassName: _propTypes.default.string,
  saveDisabled: _propTypes.default.bool,
  saveText: _propTypes.default.string.isRequired,
  saveTooltip: _propTypes.default.shape({
    confirmButtonText: _propTypes.default.string,
    cancelButtonText: _propTypes.default.string,
    label: _propTypes.default.node,
    messageText: _propTypes.default.node,
    onConfirm: _propTypes.default.func,
    onCancel: _propTypes.default.func,
    open: _propTypes.default.bool,
    title: _propTypes.default.string
  }),
  enableSavingAnimation: _propTypes.default.bool,
  unfixed: _propTypes.default.bool,
  visible: _propTypes.default.bool,
  useButtonForCancel: _propTypes.default.bool
});
(0, _defineProperty2.default)(ButtonBar, "defaultProps", {
  alignment: "left",
  cancelText: "Cancel",
  "data-id": "button-bar",
  saveDisabled: false,
  saveText: "Save",
  discardText: "Discard Changes",
  enableSavingAnimation: false,
  unfixed: false,
  visible: true,
  onSave: _underscore.default.noop,
  onSaveMouseDown: _underscore.default.noop,
  useButtonForCancel: false
});
(0, _defineProperty2.default)(ButtonBar, "buttonAlignments", alignments);
var _default = ButtonBar;
exports.default = _default;
module.exports = exports["default"];